import { ROUTE_VENDOR } from "@/app/infrastructures/misc/RolePermission";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const DetailVendor = () =>
  import(
    /* webpackChunkName: "Vendor" */ "@/app/ui/views/route/vendor/component/detail.vue"
  );
const EditVendor = () =>
  import(
    /* webpackChunkName: "Vendor" */ "@/app/ui/views/route/vendor/component/edit.vue"
  );

export default [
  {
    path: "/network/vendor",
    component: Layout,
    name: "detail-vendor",
    meta: {
      hidden: true,
      parent: "Vendor",
      permission: ROUTE_VENDOR.DETAIL
    },
    children: [
      {
        path: ":id",
        name: "detail-vendor",
        component: DetailVendor,
        meta: {
          header: true,
          title: "Vendor | Detail"
        }
      }
    ]
  },
  {
    path: "/network/vendor",
    component: Layout,
    name: "edit-vendor",
    meta: {
      icon: "vendor",
      children: false,
      hidden: true,
      parent: "Vendor",
      permission: ROUTE_VENDOR.EDIT
    },
    children: [
      {
        path: ":id/edit",
        name: "edit-vendor",
        component: EditVendor,
        meta: {
          header: true,
          title: "Vendor | Edit",
          name: "Edit",
          before: "/network/vendor/:id"
        }
      }
    ]
  }
];
